import PropTypes from 'prop-types';

const propTypes = {
  condition: PropTypes.bool,
  whenTrue: PropTypes.node,
  whenFalse: PropTypes.node,
};

function IfComponent({ condition, whenFalse, whenTrue }) {
  return condition ? whenTrue : whenFalse;
}

IfComponent.propTypes = propTypes;

export default IfComponent;
